/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Status_DeclinedInputs */

const en_team_status_declined = /** @type {(inputs: Team_Status_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declined`)
};

const es_team_status_declined = /** @type {(inputs: Team_Status_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazado`)
};

const fr_team_status_declined = /** @type {(inputs: Team_Status_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refusé`)
};

const de_team_status_declined = /** @type {(inputs: Team_Status_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgelehnt`)
};

const id_team_status_declined = /** @type {(inputs: Team_Status_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditolak`)
};

/** @type {(inputs: Team_Status_DeclinedInputs) => LocalizedString} */
const ja_team_status_declined = en_team_status_declined;

/** @type {(inputs: Team_Status_DeclinedInputs) => LocalizedString} */
const zh_team_status_declined = en_team_status_declined;

/** @type {(inputs: Team_Status_DeclinedInputs) => LocalizedString} */
const ar_team_status_declined = en_team_status_declined;

/** @type {(inputs: Team_Status_DeclinedInputs) => LocalizedString} */
const it_team_status_declined = en_team_status_declined;

/** @type {(inputs: Team_Status_DeclinedInputs) => LocalizedString} */
const ru_team_status_declined = en_team_status_declined;

/** @type {(inputs: Team_Status_DeclinedInputs) => LocalizedString} */
const pt_team_status_declined = en_team_status_declined;

/** @type {(inputs: Team_Status_DeclinedInputs) => LocalizedString} */
const ko_team_status_declined = en_team_status_declined;

/**
* | output |
* | --- |
* | "Declined" |
*
* @param {Team_Status_DeclinedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_status_declined = /** @type {((inputs?: Team_Status_DeclinedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Status_DeclinedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_status_declined(inputs)
	if (locale === "es") return es_team_status_declined(inputs)
	if (locale === "fr") return fr_team_status_declined(inputs)
	if (locale === "de") return de_team_status_declined(inputs)
	if (locale === "ja") return ja_team_status_declined(inputs)
	if (locale === "zh") return zh_team_status_declined(inputs)
	if (locale === "ar") return ar_team_status_declined(inputs)
	if (locale === "id") return id_team_status_declined(inputs)
	if (locale === "it") return it_team_status_declined(inputs)
	if (locale === "ru") return ru_team_status_declined(inputs)
	if (locale === "pt") return pt_team_status_declined(inputs)
	return ko_team_status_declined(inputs)
});